<template>
  <div>
    <a
      :href="media.url"
      target="_blank"
      class="block relative bg-gray-100"
      style="padding-bottom: 66.666667%"
    >
      <img v-if="cover" :src="cover" class="absolute w-full h-full object-cover" />
      <div v-else class="absolute w-full h-full inline-flex items-center justify-center">
        <div class="flex flex-col items-center space-y-4">
          <svg viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12 text-gray-600">
            <path
              v-if="isPDF"
              fill="currentColor"
              class="text-red-600"
              d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9
              2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5
              1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67
              1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5
              1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4
              6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
            />
            <path
              v-else-if="isVideo"
              fill="currentColor"
              class="text-indigo-600"
              d="M12 20h8v2h-8C6.477 22 2 17.523 2 12S6.477 2
              12 2s10 4.477 10 10a9.956 9.956 0 0 1-2 6h-2.708A8
              8 0 1 0 12 20zm0-10a2 2 0 1 1 0-4 2 2 0 0 1 0
              4zm-4 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm8 0a2 2
              0 1 1 0-4 2 2 0 0 1 0 4zm-4 4a2 2 0 1 1 0-4
              2 2 0 0 1 0 4z"
            />
            <path
              v-else
              d="M12 16H8V8h4a4 4 0 1 1 0 8zm-2-6v4h2a2 2 0 1 0
              0-4h-2zm5-6H5v16h14V8h-4V4zM3 2.992C3 2.444 3.447
              2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1
              1 0 0 1 3 21.008V2.992z"
            />
          </svg>
          <p class="text-gray-900">No preview available</p>
        </div>
      </div>
    </a>
    <div v-if="!withoutActions" class="flex">
      <portal :to="`media-${media.id}-actions`">
        <BaseButton v-if="media.url" ghost squared @click="copyUrl" class="flex-1 text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="inline-block w-4 h-4 focus:outline-none"
            v-tip="{ content: 'copy to clipboard' }"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1
              1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001
              1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.007-1H7zM5.003
              8L5 20h10V8H5.003zM9 6h8v10h2V4H9v2z"
            />
          </svg>
        </BaseButton>
      </portal>
    </div>
  </div>
</template>

<script>
import copyToClipboard from '@/utils/copy-to-clipboard';

export default {
  name: 'AssetableMedia',
  props: {
    withoutActions: Boolean,
    media: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isPDF() {
      return this.media && this.media.mimeType && this.media.mimeType === 'application/pdf';
    },
    isVideo() {
      return this.media && this.media.mimeType && this.media.mimeType.includes('video/');
    },
    cover() {
      if (this.media && this.media.mimeType && this.media.mimeType.indexOf('image') === 0) {
        return this.media.url;
      }

      return null;
    },
  },
  methods: {
    copyUrl() {
      copyToClipboard(this.media.url);
    },
  },
};
</script>
